//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import hasPages from '~/mixins/hasPages'
import hasWindow from '~/mixins/hasWindow'

const pageId = 2

export default {
  mixins: [hasPages, hasWindow],

  async fetch({ store, error }) {
    try {
      await store.dispatch('pages/maybeFetchById', pageId)
    } catch (e) {
      if (get(e, 'response.status') === 404) {
        error({ statusCode: 404, message: 'Halaman tidak ditemukan.' })
      } else {
        throw e
      }
    }
  },

  computed: {
    page() {
      return this.findPage(pageId)
    },

    content() {
      return this.$auth.isGirl && this.page.content_girl
        ? this.page.content_girl
        : this.page.content
    },
  },

  head() {
    return {
      title: 'Membahas Seputar Menstruasi dan Pubertas Remaja | Charmgirlstalk',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Charm Girl’s Talk hadir untuk girls dan parents sebagai upaya edukasi terkait tren menstruasi dini yang terjadi pada anak saat ini. #TakAdaMomenTerlewatkan',
        },
      ],
    }
  },
}
